const RecommendationFilters = {
    init: () => {
        if (!document.getElementById("filters-form")) {
            return;
        }

        const checkboxes = document.querySelectorAll(
            "#filters-form input[type='checkbox']",
        );
        const cards = document.querySelectorAll(".card[data-factor-values]");
        const noMatches = document.getElementById("no-matches");

        const updateVisibility = () => {
            // Get all checked checkboxes' values
            const checkedValues = Array.from(checkboxes)
                .filter((checkbox) => checkbox.checked)
                .map((checkbox) => checkbox.value);

            noMatches.style.display = "none";

            // If no checkboxes are checked, show all cards
            if (checkedValues.length === 0) {
                cards.forEach((card) => {
                    card.style.display = "";
                });
                return;
            }

            // Check each card
            let matchCount = 0;
            cards.forEach((card) => {
                const factorValues = card
                    .getAttribute("data-factor-values")
                    .split(",");

                // Check if the card contains ALL checked values
                const containsAllValues = checkedValues.every((value) =>
                    factorValues.includes(value),
                );

                if (containsAllValues) {
                    matchCount++;
                }

                // Show or hide the card based on the check
                card.style.display = containsAllValues ? "" : "none";
            });

            if (matchCount === 0) {
                noMatches.style.display = "";
            }
        };

        const updateOrder = () => {
            const sortValue = document.getElementById("sort").value;
            const cardsArray = Array.from(cards);

            if (cardsArray.length === 0) return;

            // Get the container by finding the parent of the first card
            const cardsContainer = cardsArray[0].parentElement;

            // Sort the cards based on the selected option
            cardsArray.sort((a, b) => {
                let aValue, bValue;

                switch (sortValue) {
                    case "rank":
                        aValue = parseInt(a.getAttribute("data-rank")) || 0;
                        bValue = parseInt(b.getAttribute("data-rank")) || 0;
                        return aValue - bValue; // Ascending order for rank

                    case "name":
                        aValue = a.getAttribute("data-name") || "";
                        bValue = b.getAttribute("data-name") || "";
                        return aValue.localeCompare(bValue); // Alphabetical order

                    case "range":
                        aValue = parseInt(a.getAttribute("data-range")) || 0;
                        bValue = parseInt(b.getAttribute("data-range")) || 0;
                        return bValue - aValue; // Descending order for range (higher range first)

                    case "range-asc":
                        aValue = parseInt(a.getAttribute("data-range")) || 0;
                        bValue = parseInt(b.getAttribute("data-range")) || 0;
                        return aValue - bValue; // Ascending order for range (lower range first)

                    default:
                        return 0;
                }
            });

            // Reorder the cards in the DOM
            cardsArray.forEach((card) => {
                cardsContainer.appendChild(card);
            });
        };

        // Add change event listener to each checkbox
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", updateVisibility);
        });

        document.getElementById("sort").addEventListener("change", updateOrder);

        // Initialize visibility on page load
        updateOrder();
        updateVisibility();
    },
};

export { RecommendationFilters };
